/*
 * Copyright (c) 2019 Frontier Developments PLC.
 */

import {Module} from 'vuex';
import {RootState} from '@/store/types';
import {getters} from '@/store/modules/trophy-cabinet/getters';
import {actions} from '@/store/modules/trophy-cabinet/actions';
import {mutations} from '@/store/modules/trophy-cabinet/mutations';
import {TrophyState, TrophyStateInterface} from '@/store/modules/trophy-cabinet/types';

/**
 * The trophy-cabinet store module.
 * This module is imported by vuex as a representation of the franchise achievements.
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
export const state: TrophyStateInterface = new TrophyState();

const namespaced: boolean = true;

export const trophyCabinetModule: Module<TrophyStateInterface, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
